import { UserAvatar } from '../UserAvatar';

import s from './UserChip.module.scss';

/** Пользователь в списках: аватар и имя */
const UserChip: React.FC<{ name: string }> = ({ name }) => (
  <span className={s.chip} title={name}>
    <UserAvatar name={name} />
    <span className={s.chip__name}>{name}</span>
  </span>
);

export { UserChip };
